import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { UserLocationModel } from '../Models/UserLocationModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../Models/ResultModel';


@Injectable()
export class UserLocationServices {
  apiURL: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.apiURL = baseUrl + 'api/UserLocation/';
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.apiURL = sessionStorage.getItem("BaseURL") || '';
      this.apiURL = this.apiURL + 'api/UserLocation';
    }
  }


  GetUserLocation(TokenKey: string, UserID: number): Observable<UserLocationModel[]> {
    let fullAPIPath = this.apiURL + '/GetUserLocation/' + UserID;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this.http.get<UserLocationModel[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  SaveLocationdMaster(TokenKey: string, uLocation: any[]): Observable<number> {
    let fullAPIPath = this.apiURL + '/AddUserLocation';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this.http.post<number>(fullAPIPath, uLocation, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private extractData(res: Response) {
    let body = res.json();
    //console.log("extractData " + body);
    return body;
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
